import { Tag } from 'antd';
import {
  stockBalanceHistoriesTypeColors,
  stockBalanceHistoryStatusColors,
  stockBalanceHistoryStatusLabels,
} from 'apps/investment/constants/stock-balance-histories';
import InfoCard from 'common/ui/info-card';
import { Link } from 'react-router-dom';
import { formatCurrency } from 'utils/formatAmount';
import { formatDate, formatDateTime } from 'utils/formatDate';

const ItemDetail = ({ item }) => {
  const {
    id,
    amount,
    balance,
    type,
    type_label,
    trade_date,
    stock_seq_no,
    stock_sub_no,
    note,
    created_at,
    user,
    status,
  } = item || {};

  const renderValue = value => {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    return value;
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <InfoCard
          label="Type"
          value={
            <Tag
              className="mx-auto"
              color={stockBalanceHistoriesTypeColors[type]}
            >
              {type_label || type}
            </Tag>
          }
        />
        <InfoCard label="Amount" value={formatCurrency(amount)} />
        <InfoCard label="Balance" value={formatCurrency(balance)} />
        <InfoCard
          label="Status"
          value={
            <Tag
              className="mx-auto"
              color={stockBalanceHistoryStatusColors[status]}
            >
              {stockBalanceHistoryStatusLabels[status] || status}
            </Tag>
          }
        />

        <InfoCard
          label="Trade Date"
          value={trade_date ? formatDate(trade_date) : '-'}
        />
        <InfoCard
          label="Created At"
          value={created_at ? formatDateTime(created_at) : '-'}
        />
        <InfoCard
          className="md:col-span-3"
          label="Note"
          value={renderValue(note)}
        />

        <InfoCard label="Stock Seq No" value={renderValue(stock_seq_no)} />
        <InfoCard label="Stock Sub No" value={renderValue(stock_sub_no)} />

        <InfoCard
          label="User"
          value={
            user ? (
              <Link to={`/investment/users/${user.id}`}>{user.email}</Link>
            ) : (
              '-'
            )
          }
        />
      </div>
    </div>
  );
};

export default ItemDetail;
